/**
 * Normalizes image URLs to absolute HTTPS URLs
 * Handles relative URLs, protocol-relative URLs, and validates protocols
 * 
 * @param {string} url - The image URL to normalize
 * @param {string} baseUrl - The base URL of the page (for relative paths)
 * @returns {string|null} - The normalized URL or null if invalid
 */
export function normalizeImageUrl(url, baseUrl) {
  if (!url) return null;
  
  try {
    // Protocol-relative URLs: //cdn.example.com/image.png → https://cdn.example.com/image.png
    if (url.startsWith('//')) {
      return `https:${url}`;
    }
    
    // Relative URLs: /path/to/image.png → https://example.com/path/to/image.png
    if (url.startsWith('/')) {
      const domain = new URL(baseUrl).origin;
      return `${domain}${url}`;
    }
    
    // Must start with http:// or https://
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      console.warn('⚠️ Invalid image URL (no protocol):', url);
      return null;
    }
    
    // Already a valid absolute URL
    return url;
    
  } catch (error) {
    console.error('❌ Failed to normalize image URL:', url, error);
    return null;
  }
}
